import {useEffect,useState} from 'react';
import {doc,onSnapshot,setDoc} from 'firebase/firestore';
import {db} from '../Security/firebase-config';
import {normalizeTeamAppearance} from './teamAppearanceModel';

const cacheKey=(uid,path)=>`valovate.appearance.v1.${uid}.${path}`;
const valid=(kind,value)=>kind==='team'?normalizeTeamAppearance(value)
  : value?.version===1 && typeof value.useValovate==='boolean'?{version:1,useValovate:value.useValovate}:null;
const read=(uid,path,kind)=>{try{return valid(kind,JSON.parse(localStorage.getItem(cacheKey(uid,path))));}catch{return null;}};
export function appearancePath(kind,id){return kind==='team'?`teams/${id}/settings/appearance`:`users/${id}/settings/appearance`;}
const EVENT='valovate-appearance-saved';
export function useAppearanceRecord(kind,id,uid,database=db) {
  const path=id && uid?appearancePath(kind,id):null;
  const identity=path?uid+':'+path:null;
  const [state,setState]=useState({identity:null,value:null,loading:false,error:null});
  useEffect(()=>{
    if(!identity || !database)return undefined;
    let alive=true;
    setState({identity,value:read(uid,path,kind),loading:true,error:null});
    const receive=value=>{
      if(!alive)return;
      const normalized=valid(kind,value);
      try{if(normalized)localStorage.setItem(cacheKey(uid,path),JSON.stringify(normalized));else localStorage.removeItem(cacheKey(uid,path));}catch{}
      setState({identity,value:normalized,loading:false,error:null});
    };
    const stop=onSnapshot(doc(database,...path.split('/')),{includeMetadataChanges:true},snapshot=>{
      if(snapshot.metadata?.fromCache && !snapshot.exists()) {
        if(alive)setState(previous=>({...previous,loading:false}));
        return;
      }
      receive(snapshot.exists()?snapshot.data():null);
    },error=>{
      if(!alive)return;
      const denied=String(error.code || '').includes('permission-denied');
      if(denied){try{localStorage.removeItem(cacheKey(uid,path));}catch{}}
      setState(previous=>({identity,value:denied?null:previous.value,loading:false,error}));
    });
    const saved=event=>{if(event.detail?.path===path)receive(event.detail.value);};
    window.addEventListener(EVENT,saved);
    return()=>{alive=false;stop();window.removeEventListener(EVENT,saved);};
  },[identity,path,id,uid,kind,database]);
  return state.identity===identity?state:{identity,value:path?read(uid,path,kind):null,loading:Boolean(path),error:null};
}
export async function saveAppearanceRecord(kind,id,uid,value,database=db){
  const normalized=valid(kind,value);
  if(!uid || !id || !normalized)throw new Error('Choose a valid appearance before saving.');
  const path=appearancePath(kind,id);
  await setDoc(doc(database,...path.split('/')),{...normalized,updatedBy:uid,updatedAt:Date.now()});
  window.dispatchEvent(new CustomEvent(EVENT,{detail:{path,value:normalized}}));
  return normalized;
}
